import styles from './SearchInput.module.scss';
import { ReactComponent as SearchIcon } from '../../../assets/svg/icons/cerca.svg';
import { ReactComponent as CloseIcon } from '../../../assets/svg/cross.svg';
import clx from 'classnames';

const SearchInput = ({
  placeholder = '',
  value = '',
  setValue,
  onKeyDown,
  backgroundColor,
  fullWidth = false,
  compact = false,
  autoFocus = false,
  className,
}) => (
  <div
    className={clx(styles.search_field__wrapper, className, {
      [styles.search_field__full_width]: fullWidth,
      [styles.search_field__compact]: compact,
    })}
  >
    <SearchIcon className={styles.search_icon} />
    <CloseIcon
      className={clx(styles.close_icon, {
        [styles['hide']]: !value,
      })}
      onClick={() => setValue('')}
      role="button"
      tabIndex={0}
      aria-label="Cancella ricerca"
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setValue('');
        }
      }}
    />
    <input
      type="search"
      value={value}
      placeholder={placeholder}
      onChange={(event) => setValue(event.target.value)}
      onKeyDown={onKeyDown}
      className={styles['field__value']}
      autoFocus={autoFocus}
      enterKeyHint="search"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck={false}
      style={{
        ...(backgroundColor && { backgroundColor }),
      }}
    />
  </div>
);

export default SearchInput;
